var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2535 2H6.74677C6.33425 2 6 2.36137 6 2.80807V6.34353C6 8.78906 7.25666 10.9214 9.10716 12.0284C7.25696 13.1355 6 15.2678 6 17.7134V21.1919C6 21.297 6.02001 21.402 6.05765 21.5006C6.13322 21.6984 6.27899 21.8558 6.4615 21.9376C6.55261 21.9783 6.64969 22 6.74677 22H17.2532C17.3503 22 17.4474 21.9787 17.5385 21.9376C17.7213 21.8558 17.8668 21.6984 17.9423 21.5006C17.98 21.402 18 21.297 18 21.1919V17.7134C18 15.2678 16.7433 13.1355 14.8928 12.0284C16.743 10.9214 18 8.78906 18 6.34353V2.80807C18.0003 2.36169 17.6657 2 17.2535 2ZM7.49354 3.61614H16.5065C16.5065 7.14707 16.5 7 16 7.5C16 7.5 13 8.57567 12.0001 8.57567C10.9971 8.57567 8.5 8 8 7.5C7.5 7 7.49393 7.14707 7.49354 3.61614ZM12.0001 16.6496L15.4508 20.3839H8.54947L12.0001 16.6496ZM11.2534 12.9092V15.1725L7.49354 19.2409V17.7134C7.49354 15.2998 9.12329 13.2961 11.2534 12.9092ZM16.5068 17.7134V19.2409L12.7469 15.1721V12.9089C14.877 13.2961 16.5068 15.2998 16.5068 17.7134Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 16.6496L15.4508 20.3839H8.54947L12.0001 16.6496Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWaiting);
export default __webpack_public_path__ + "static/media/ico-waiting.a815f9cd.svg";
export { ForwardRef as ReactComponent };